import { FC, useState } from "react";
import {
    FormContainerStateReturnType,
    useAppUtil,
    // useDownloadFile,
    useTrans,
} from "../../../hooks";
import { DonationTransaction, DonationTransactionApi } from "../../../apis";
import {
    Badge,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Table,
    TableContainer,
    Tbody,
    Td,
    Tr,
    Text,
    Button,
} from "@chakra-ui/react";
import { AppLoader } from "../../../components";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { BE } from "../../../config/appConstant";
import { APPC } from "../../../config";

export const DonationTransactionDetailView: FC<{
    formContainerState: FormContainerStateReturnType;
    data: DonationTransaction;
    loading: boolean;
}> = ({ formContainerState, data, loading }) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);

    const { t } = useTrans();
    const { statusVariant } = useAppUtil();

    const [isDownloading, setIsDownloading] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
    const [isCancelShow, setIsCancelShow] = useState(true);

    const downloadReceiptHandler = () => {
        setIsDownloading(true);
        if (data) {
            DonationTransactionApi.getItemDownloadReceipt<any>(data?.id)
                .then(({ response }) => {
                    if (response !== null) {
                        const fileURL = URL.createObjectURL(
                            new Blob([response], { type: "application/pdf" })
                        );

                        // Setting various property values
                        const alink = document.createElement("a");
                        alink.href = fileURL;
                        alink.download = "donation_receipt.pdf";
                        alink.click();
                    }
                })
                .finally(() => setIsDownloading(false));
        }
    };

    const cancelSubscriptionHandler = () => {
        setIsCancelling(true);
        if (data) {
            DonationTransactionApi.getItemCancelSubscription<DonationTransaction>(
                data?.id
            )
                .then(({ response }) => {
                    if (response !== null) {
                        console.log(response);
                        setIsCancelShow(false);
                    }
                })
                .finally(() => setIsCancelling(false));
        }
    };

    return (
        <>
            {loading ? (
                <AppLoader />
            ) : (
                <Drawer
                    size={"lg"}
                    isOpen={formContainerState.isOpen}
                    placement="right"
                    onClose={() => formContainerState.close()}
                >
                    <DrawerOverlay />
                    <DrawerContent>
                        <DrawerCloseButton />
                        <DrawerHeader>
                            {t("padm.DonationTransactionPage:text.pageTitle")}
                        </DrawerHeader>
                        <DrawerBody>
                            <TableContainer>
                                <Table variant="simple">
                                    <Tbody>
                                        <Tr mb={2}>
                                            <Td pe={2}>
                                                <Text textStyle={"semiBoldLg"}>
                                                    {t(
                                                        "padm.DonationTransactionPage:label.transaction"
                                                    )}
                                                </Text>
                                            </Td>
                                            <Td textAlign="right">
                                                {data?.status ===
                                                    BE.DonationTransaction
                                                        .TRANSACTION_STATUS_SUCCESS && (
                                                    <Button
                                                        isLoading={
                                                            isDownloading
                                                        }
                                                        size="sm"
                                                        onClick={
                                                            downloadReceiptHandler
                                                        }
                                                    >
                                                        {t(
                                                            "padm.DonationTransactionPage:button.downloadReceipt"
                                                        )}
                                                    </Button>
                                                )}
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t(
                                                    "ent.DonationTransaction:id.label"
                                                )}
                                            </Td>
                                            <Td ps={2}>{`DT-${dayjs(
                                                data?.createdAt
                                            )
                                                .tz(APPC.TIMEZONE)
                                                .format(
                                                    "YYYYMMDD"
                                                )}-${data?.id}`}</Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t(
                                                    "ent.DonationTransaction:amount.label"
                                                )}
                                            </Td>
                                            <Td ps={2}>
                                                &euro; {data?.amount / 100}
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t(
                                                    "ent.DonationTransaction:assignment.label"
                                                )}
                                            </Td>
                                            <Td ps={2}>
                                                {data?.assignment &&
                                                    t(
                                                        `con.DonationTransaction:assignment.${data?.assignment}`
                                                    )}
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t(
                                                    "ent.DonationTransaction:createdAt.label"
                                                )}
                                            </Td>
                                            <Td ps={2}>
                                                {dayjs(data?.createdAt)
                                                    .tz(APPC.TIMEZONE)
                                                    .format(
                                                        "DD-MM-YYYY HH:mm:ss"
                                                    )}
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t(
                                                    "ent.DonationTransaction:status.label"
                                                )}
                                            </Td>
                                            <Td ps={2}>
                                                <Badge
                                                    variant={statusVariant(
                                                        data.status
                                                    )}
                                                >
                                                    {data.status}
                                                </Badge>
                                            </Td>
                                        </Tr>
                                        {data?.isSubscription && (
                                            <>
                                                <Tr mb={2}>
                                                    <Td pe={2}>
                                                        <Text
                                                            textStyle={
                                                                "semiBoldLg"
                                                            }
                                                        >
                                                            {t(
                                                                "ent.DonationTransaction:subscription.label"
                                                            )}
                                                        </Text>
                                                    </Td>
                                                    <Td textAlign="right">
                                                        {isCancelShow &&
                                                            data?.subscriptionStatus ===
                                                                BE
                                                                    .DonationTransaction
                                                                    .TRANSACTION_SUBSCRIPTIONSTATUS_STARTED && (
                                                                <Button
                                                                    isLoading={
                                                                        isCancelling
                                                                    }
                                                                    size="sm"
                                                                    onClick={
                                                                        cancelSubscriptionHandler
                                                                    }
                                                                >
                                                                    {t(
                                                                        "padm.DonationTransactionPage:button.cancelSubscription"
                                                                    )}
                                                                </Button>
                                                            )}
                                                    </Td>
                                                </Tr>
                                                <Tr>
                                                    <Td pe={2}>
                                                        {t(
                                                            "ent.DonationTransaction:effectDate.label"
                                                        )}
                                                    </Td>
                                                    <Td ps={2}>
                                                        {dayjs(data?.effectDate)
                                                            .tz(APPC.TIMEZONE)
                                                            .format(
                                                                "DD-MM-YYYY HH:mm:ss"
                                                            )}
                                                        <Badge
                                                            variant={"solid"}
                                                            ml={2}
                                                        >
                                                            {t(
                                                                "padm.DonationTransactionPage:text.monthly"
                                                            )}
                                                        </Badge>
                                                    </Td>
                                                </Tr>
                                                {/*
                                                    <Tr>
                                                        <Td pe={2}>
                                                            {t(
                                                                "ent.DonationTransaction:initialAmount.label"
                                                            )}
                                                        </Td>
                                                        <Td ps={2}>
                                                            &euro;{" "}
                                                            {data?.initialAmount /
                                                                100}
                                                        </Td>
                                                    </Tr>
                                                    <Tr>
                                                        <Td pe={2}>
                                                            {t(
                                                                "ent.DonationTransaction:initialAmountNumber.label"
                                                            )}
                                                        </Td>
                                                        <Td ps={2}>
                                                            {
                                                                data?.initialAmountNumber
                                                            }
                                                        </Td>
                                                    </Tr>
                                                    <Tr>
                                                        <Td pe={2}>
                                                            {t(
                                                                "ent.DonationTransaction:rrule.label"
                                                            )}
                                                        </Td>
                                                        <Td ps={2}>
                                                            {data?.rrule}
                                                        </Td>
                                                    </Tr>
                                                */}
                                            </>
                                        )}
                                        <Tr mb={2}>
                                            <Td pe={2}>
                                                <Text textStyle={"semiBoldLg"}>
                                                    {t(
                                                        "ent.DonationTransaction:customer.label"
                                                    )}
                                                </Text>
                                            </Td>
                                            <Td></Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t(
                                                    "ent.DonationTransaction:customer.reference.label"
                                                )}
                                            </Td>
                                            <Td ps={2}>
                                                {data?.customer?.reference}
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t("ent.User:email.label")}
                                            </Td>
                                            <Td ps={2}>
                                                {data?.customer?.email}
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t("ent.User:name.label")}
                                            </Td>
                                            <Td ps={2}>
                                                {`${data?.customer?.billingDetails?.title} ${data?.customer?.billingDetails?.firstName} ${data?.customer?.billingDetails?.lastName}`}
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t("ent.User:address.label")}
                                            </Td>
                                            <Td ps={2}>
                                                <Text whiteSpace="pre-wrap">
                                                    {
                                                        data?.customer
                                                            ?.billingDetails
                                                            ?.address
                                                    }
                                                </Text>
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t("ent.User:postalCode.label")}
                                            </Td>
                                            <Td ps={2}>
                                                {
                                                    data?.customer
                                                        ?.billingDetails
                                                        ?.zipCode
                                                }
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t("ent.User:city.label")}
                                            </Td>
                                            <Td ps={2}>
                                                {
                                                    data?.customer
                                                        ?.billingDetails?.city
                                                }
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td pe={2}>
                                                {t("ent.User:country.label")}
                                            </Td>
                                            <Td ps={2}>
                                                {
                                                    data?.customer
                                                        ?.billingDetails
                                                        ?.country
                                                }
                                            </Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </DrawerBody>
                    </DrawerContent>
                </Drawer>
            )}
        </>
    );
};
